import { clearExpiredCache } from './';

let cleanupInterval = null;

export const setupCacheCleanup = (store) => {
    if (cleanupInterval) return;

    cleanupInterval = setInterval(
        () => {
            store.dispatch(clearExpiredCache());
        },
        5 * 60 * 1000,
    );
};

export const stopCacheCleanup = () => {
    if (cleanupInterval) {
        clearInterval(cleanupInterval);
        cleanupInterval = null;
    }
};
